import React, { useContext, useEffect, useState } from 'react'
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material'
import { PATHS } from '../../constants'
import { EmploymentsContext } from '../../contexts/EmploymentsContext'
import { changeSelectedStore } from '../../Utilities/authenticationService'
import { isMobile } from '../../Utilities/isMobile'
import { AxiosWithAuth } from '../../Utilities/authenticationService'

const UserManagementStores = ({ history }) => {
    const { userEmployments: employments } = useContext(EmploymentsContext)
    const [storeTypes, setStoreTypes] = useState([])

    useEffect(() => {
        AxiosWithAuth.get('/store_types')
            .then(res => {
                setStoreTypes(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    return (
        <>
            <Table sx={{ width: !isMobile ? '45rem' : '95%', marginTop: '1rem' }} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: '5rem' }} align="left">
                            店舗名
                        </TableCell>
                        <TableCell sx={{ width: '5rem' }} align="left">
                            店舗タイプ
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {employments.map(e =>
                    e.is_manager ? (
                        <TableRow
                            key={e.id}
                            onClick={() => {
                                changeSelectedStore(e.id)
                                history.push(PATHS.managerSettingsStore.replace(':segCode', e.store.seg_code))
                            }}
                        >
                            <TableCell align="left">{e.store.name}</TableCell>
                            <TableCell align="left">{storeTypes.find(s => s.id === e.store.store_type_id)?.brand_name}</TableCell>
                        </TableRow>
                    ) : null
                )}
                </TableBody>
            </Table>
        </>
    )
}

export default UserManagementStores
